sap.ui.define(["sap/ui/core/library", 'sap/uxap/BlockBase'], function (coreLibrary, BlockBase) {
	"use strict";

	var ViewType = coreLibrary.mvc.ViewType;

	var Departments = BlockBase.extend("com.reply.leaviosa.blocks.admin.Departments", {
		metadata: {
			views: {
				Collapsed: {
					viewName: "com.reply.leaviosa.blocks.admin.Departments",
					type: ViewType.XML
				},
				Expanded: {
					viewName: "com.reply.leaviosa.blocks.admin.Departments",
					type: ViewType.XML
				}
			}
		}
	});

	return Departments;
});